import React from 'react';
import { Check } from 'lucide-react';
import './Overview.css';

const Overview = () => {
  const steps = [
    { num: 1, label: 'Onboarding', status: 'completed' },
    { num: 2, label: 'Drafting', status: 'active' },
    { num: 3, label: 'Review', status: 'pending' },
    { num: 4, label: 'Submission', status: 'pending' },
    { num: 5, label: 'Evaluation', status: 'pending' },
    { num: 6, label: 'Outcome', status: 'pending' },
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title">
          <h1>TwinOxis — QRYX Tech Pvt. Ltd.</h1>
          <div className="page-meta">
            CASE NO. SSI/ENG/2026/TWX-001 • TARGET: GUSEC / iHub / Gujarat Innovators Scheme
          </div>
        </div>
        <div className="status-badge">
          PHASE 2 OF 6 - DRAFTING
        </div>
      </div>

      <div className="timeline-container">
        <div className="timeline-line"></div>
        {steps.map((step) => (
          <div key={step.num} className="timeline-step">
            <div className={`step-circle ${step.status}`}>
              {step.status === 'completed' ? <Check size={16} /> : step.num}
            </div>
            <span className="step-label">{step.label}</span>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-header">
          <h2 className="card-title">Outstanding items</h2>
          <span className="card-badge">2 OPEN</span>
        </div>
        
        <div className="list-item">
          <div className="item-content">
            <h4>DOCUMENTS</h4>
            <p>Financial projections (3-5 years)</p>
          </div>
          <div className="status-pill requested">REQUESTED</div>
        </div>
        
        <div className="list-item">
          <div className="item-content">
            <h4>PAYMENTS</h4>
            <p>Balance payment on submission</p>
          </div>
          <div className="status-pill due">DUE AT PHASE 4</div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h2 className="card-title">Recent activity</h2>
        </div>
        
        <div className="list-item">
          <div className="item-content">
            <p>Advance payment of ₹5,841 received</p>
          </div>
          <span className="activity-date">2 Jul</span>
        </div>
        
        <div className="list-item">
          <div className="item-content">
            <p>Engagement agreement accepted</p>
          </div>
          <span className="activity-date">30 Jun</span>
        </div>
        
        <div className="list-item">
          <div className="item-content">
            <p>Case file created</p>
          </div>
          <span className="activity-date">28 Jun</span>
        </div>
      </div>
    </div>
  );
};

export default Overview;
